import canUseDom from '@clearscore-group/lib.helpers.can-use-dom';
import { isDevEnv } from '@clearscore-group/lib.hooks.use-tracking';

import libraries from '.';

const thirdParties = [
    {
        name: 'segment',
        library: libraries.segment,
        loaded: false,
        ssr: false,
        required: 'SEGMENT_ID',
        requiresConsent: 'marketing',
    },
    {
        name: 'appsFlyer',
        library: libraries.appsFlyer,
        loaded: false,
        ssr: false,
        required: 'APPS_FLYER_ID',
        requiresConsent: 'marketing',
    },
    {
        name: 'datadog',
        library: libraries.datadog,
        loaded: false,
        ssr: false,
        requiresConsent: 'necessary',
    },
    {
        name: 'cookiebot',
        library: libraries.cookiebot,
        loaded: false,
        ssr: false,
        required: 'COOKIEBOT_DOMAIN_ID',
        requiresConsent: 'necessary',
    },
];

function markThirdPartyAsLoaded(name) {
    const thirdParty = thirdParties.find(({ name: thirdPartyName }) => thirdPartyName === name);
    if (thirdParty) {
        thirdParty.loaded = true;
    }
}

let cookiebotListenerInitialized = false;
let currentLoadProps = null;
let currentLoadCallback = null;

function handleCookiebotAccept() {
    if (!currentLoadProps) {
        // Props not available, cannot proceed
        return;
    }
    const consent = window.Cookiebot?.consent;
    if (consent?.marketing || isDevEnv()) {
        // eslint-disable-next-line no-use-before-define
        processThirdPartyConsents(currentLoadProps, currentLoadCallback, 'marketing');
    }
    if (consent?.preferences || isDevEnv()) {
        // eslint-disable-next-line no-use-before-define
        processThirdPartyConsents(currentLoadProps, currentLoadCallback, 'preferences');
    }
}

function processThirdPartyConsents(props, callback, consentType) {
    thirdParties
        .filter(({ requiresConsent }) => requiresConsent === consentType)
        .forEach((tp) => {
            const { name, library, loaded, ssr, required } = tp;

            if (loaded) return;

            if (name === 'cookiebot' && consentType === 'necessary' && !props?.COOKIEBOT_DOMAIN_ID) {
                markThirdPartyAsLoaded(name);
                if (canUseDom()) {
                    handleCookiebotAccept();
                }
                return;
            }

            // Standard loading logic for all other cases (including cookiebot if ID is present)
            if (ssr || (canUseDom() && (!required || props?.[required]))) {
                library(props, callback);
                markThirdPartyAsLoaded(name);
            }
        });
}

const loadThirdPartyScripts = (props, callback) => {
    currentLoadProps = props;
    currentLoadCallback = callback;

    if (canUseDom() && !cookiebotListenerInitialized) {
        window.addEventListener('CookiebotOnAccept', handleCookiebotAccept, false);
        cookiebotListenerInitialized = true;
    }

    // Process necessary scripts immediately with the current props
    processThirdPartyConsents(props, callback, 'necessary');
};

export default loadThirdPartyScripts;
